import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var LivePortalCreateFormApi = /*#__PURE__*/function () {
  function LivePortalCreateFormApi(util, projectId, serviceDeskId, requestTypeId) {
    _classCallCheck(this, LivePortalCreateFormApi);
    this.util = util;
    this.projectId = projectId;
    this.serviceDeskId = serviceDeskId;
    this.requestTypeId = requestTypeId;
  }
  return _createClass(LivePortalCreateFormApi, [{
    key: "getFormChoices",
    value: function getFormChoices() {
      return this.util.get("/api/3/portal/".concat(this.serviceDeskId, "/requesttype/").concat(this.requestTypeId, "/formchoices"));
    }
  }, {
    key: "postFieldData",
    value: function postFieldData(templateFormId, request) {
      return this.util.post("/api/cloud/portal/".concat(this.serviceDeskId, "/requesttype/").concat(this.requestTypeId, "/form/").concat(templateFormId, "/fielddata"), request);
    }
  }, {
    key: "searchLabels",
    value: function searchLabels(portalId, jiraField, query) {
      var customFieldIdParam = jiraField.startsWith('customfield_') ? "customFieldId=".concat(jiraField === null || jiraField === void 0 ? void 0 : jiraField.split('_')[1], "&") : '';
      var uri = "/rest/servicedesk/1/customer/portal/".concat(portalId, "/requestType/").concat(this.requestTypeId, "/labels/suggest?").concat(customFieldIdParam, "query=").concat(query !== null && query !== void 0 ? query : '');
      return this.util.jiraGet(uri).then(function (data) {
        return data.suggestions.map(function (jiraLabel) {
          return {
            value: jiraLabel.label,
            label: jiraLabel.label
          };
        });
      }).catch(function (e) {
        // eslint-disable-next-line no-console
        console.warn(e);
        throw e;
      });
    }
  }, {
    key: "searchUsers",
    value: function searchUsers(jiraField, query) {
      //can’t use assignable API on portal because problem with customer accounts
      // the work is tracked separately by https://jdog.jira-dev.com/browse/FORM-1341
      return this.util.jiraGet( // Usage of serviceDeskId is correct here, the backend confusingly uses serviceDeskId instead of portalId
      // on the /proforma endpoint...
      "/rest/servicedesk/1/customer/portal/".concat(this.serviceDeskId, "/user-search/proforma?query=").concat(encodeURIComponent(query))).then(function (users) {
        return users.map(function (user) {
          return {
            label: user.displayName,
            value: user.id
          };
        });
      });
    }
  }, {
    key: "searchUsersWithFieldConfig",
    value: function searchUsersWithFieldConfig(portalId, jiraField, fieldConfigId, query) {
      //can’t use assignable API on portal because problem with customer accounts
      // the work is tracked separately by https://jdog.jira-dev.com/browse/FORM-1341
      if (jiraField && fieldConfigId) {
        return this.util.jiraGet("/rest/servicedesk/1/customer/portal/".concat(portalId, "/user-search?fieldName=").concat(jiraField, "&fieldConfigId=").concat(fieldConfigId, "&query=").concat(encodeURIComponent(query))).then(function (users) {
          return users.map(function (user) {
            return {
              label: user.displayName,
              value: user.id
            };
          });
        });
      } else {
        return this.searchUsers(jiraField, query);
      }
    }
  }, {
    key: "searchAffectedServices",
    value: function searchAffectedServices(query) {
      var uri = "/rest/service-registry-api/service?query=".concat(query !== null && query !== void 0 ? query : '');
      return this.util.jiraGet(uri).then(function (data) {
        return data.services.map(function (affectedService) {
          return {
            value: affectedService.id,
            label: affectedService.name
          };
        });
      }).catch(function (e) {
        // eslint-disable-next-line no-console
        console.warn(e);
        throw e;
      });
    }
  }, {
    key: "searchCmdb",
    value: function searchCmdb(jiraField, query, fieldValueMap) {
      var uri = "/rest/servicedesk/cmdb/1/customer/proforma/field/".concat(jiraField, "/autocomplete");
      return this.util.jiraPost(uri, {
        query: query,
        fieldValueMap: _objectSpread(_objectSpread({}, fieldValueMap), {}, {
          pid: this.projectId.toString(),
          requesttype: this.requestTypeId.toString()
        })
      }, 'cmdbAutocomplete').then(function (data) {
        return data.results.map(function (cmdbObject) {
          return {
            value: cmdbObject.id,
            label: cmdbObject.label,
            cmdbObject: cmdbObject
          };
        });
      });
    }
  }]);
}();